import _ from 'lodash';
import { createSelector } from 'reselect';

import fuzzysearch from 'app/common/fuzzysearch';
import {
  AGE_IN_DAYS,
  ALL,
  IS_PREMIUM,
  NAME,
  POPULARITY,
  serviceTypes,
} from 'app/service/constants';

// FIXME(vitorbal,neilff): all of the selectors that depend on `selectServices` won't work with `withServicesDataById`
// because it adds the query results to a `services` prop instead of `data.services`. We should fix that.
export const selectServices = (state, props) =>
  _.get(props, ['data', 'services'], []);

export const selectServicesMap = createSelector(selectServices, services =>
  _.keyBy(services, 'key')
);

export const selectSelectedServices = state =>
  _.get(state, ['service', 'selectedServices']);

export const selectServiceCategories = createSelector(
  selectServices,
  services => services.map(service => _.get(service, ['categories'], []))
);

export const searchServices = (querySelector, serviceSelector) =>
  createSelector(querySelector, serviceSelector, (queryString, services) =>
    _.filter(services, service => fuzzysearch(queryString, service.name))
  );

/**
 * Returns a map of { [categorySlug]: { name, slug } }
 */
export const selectServiceCategoryNames = createSelector(
  selectServiceCategories,
  (serviceCategories = []) =>
    _.reduce(
      serviceCategories,
      (acc, categories) => {
        return categories.reduce(
          (accum, cat) => ({
            ...accum,
            [cat.name]: cat,
          }),
          acc
        );
      },
      {}
    )
);

export const selectServiceCategoryNamesAlphabetical = createSelector(
  selectServiceCategoryNames,
  categories => _.sortBy(_.values(categories), NAME)
);

export const isSortingOnCategory = sortRuleSelector =>
  createSelector(
    sortRuleSelector,
    selectServiceCategoryNames,
    (serviceSortingRule, categoryMap = {}) => {
      // Return false for `All` because everything should be shown, can't filter on `All`
      if (serviceSortingRule === ALL) {
        return false;
      }

      return _.has(categoryMap, serviceSortingRule);
    }
  );

export const filterServicesByCategory = (
  serviceSelector,
  sortRuleSelector,
  querySelector
) =>
  createSelector(
    searchServices(querySelector, serviceSelector),
    isSortingOnCategory(sortRuleSelector),
    sortRuleSelector,
    (services, sortedOnCategory, serviceSortingRule) => {
      if (!sortedOnCategory) {
        return services;
      }

      return services.filter(service => {
        return _.some(
          service.categories || [],
          category => category.name === serviceSortingRule
        );
      });
    }
  );

export const sortServicesByTypeAndCategory = (
  serviceSelector,
  sortRuleSelector,
  querySelector
) =>
  createSelector(
    filterServicesByCategory(serviceSelector, sortRuleSelector, querySelector),
    isSortingOnCategory(sortRuleSelector),
    sortRuleSelector,
    (services, sortedOnCategory, serviceSortingRule) => {
      if (sortedOnCategory || serviceSortingRule === serviceTypes[POPULARITY]) {
        return _.orderBy(services, [POPULARITY], ['asc']);
      }

      if (serviceSortingRule === serviceTypes[NAME]) {
        return _.orderBy(services, [NAME], ['asc']);
      }

      if (serviceSortingRule === serviceTypes[AGE_IN_DAYS]) {
        return _.orderBy(services, [AGE_IN_DAYS], ['asc']);
      }

      if (serviceSortingRule === serviceTypes[IS_PREMIUM]) {
        return _.orderBy(services, [IS_PREMIUM, NAME], ['desc', 'asc']);
      }

      return services;
    }
  );
